<template>
    <Doughnut
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </template>
  
  <script>
  import { Doughnut } from 'vue-chartjs/legacy'
  
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale
  } from 'chart.js'
  
  ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)
  
  export default {
    name: 'DoughnutChart',
    components: {
      Doughnut
    },
    props: {
      chartId: {
        type: String,
        default: 'doughnut-chart'
      },
      datasetIdKey: {
        type: String,
        default: 'label'
      },
      width: {
        type: Number,
        default: 400
      },
      height: {
        type: Number,
        default: 400
      },
      cssClasses: {
        default: '',
        type: String
      },
      styles: {
        type: Object,
        default: () => {}
      },
      plugins: {
        type: Array,
        default: () => []
      },
      chartData: {
        type: Object,
        default: () => ({
          labels: ['UNJ', 'UGM', 'ITB', 'UI', 'UNPAD', 'UIB'],
          datasets: [
            {
              label: 'Pencapaian',
              data: [4, 2, 10, 22, 1, 5],
              backgroundColor: ['#2E32FF', '#9EC900', '#C96200', '#C9003C', '#C700C9', '#7500C9', '#008DC9', '#00C955'],
              borderColor: '#1A1B77',
              borderRadius: 5,
            }
          ]
        })
      }
    },
    data() {
      return {
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
              legend: {
                  position: 'bottom',
                  display: false
              }
          }
        }
      }
    },
    created() {
        ChartJS.defaults.color       = '#ffffff';
        ChartJS.defaults.borderColor = '#2E2FCA';
        ChartJS.defaults.font.family = "'Cerebri Sans',sans-serif";
    }
  }
  </script>
  